import { Middleware } from "react-tooltip"
import { Action, Dispatch, MiddlewareAPI } from "@reduxjs/toolkit"

interface CustomAction extends Action {
  error?: boolean
  payload?: {
    status?: number
  }
}

export const authMiddleware: Middleware =
  (_props: MiddlewareAPI) => (next: Dispatch<CustomAction>) => (action: CustomAction) => {
    const isOauthRoute = window.location.pathname.startsWith("/oauth")

    if (action.error && action.payload?.status === 401 && window.location.pathname !== "/auth/sign-in") {
      window.location.href = isOauthRoute ? `/oauth/sign-in${window.location.search}` : "/"
    }

    return next(action)
  }
